import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductLabelModel } from '@notino/react-styleguide-v20';

import { Bold } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { IProductItemBodyProps, IProductItemBodyWithLinkProps } from './model';
import {
  StyledInSaleTag,
  StyledSubName,
  StyledProductLink,
  SLoyaltyRewardLabel,
  SLoyaltyRewardGiftIcon,
  SLoyaltyRewardWrapper,
} from './styled';

export const ProductItemBody: ReactFCV<IProductItemBodyProps> = ({
  brand,
  name,
  subName,
  disabled,
  isGift,
  addedByCoupon,
  isTryItFirst,
  tryItFirstProductLabel,
  giftProductLabel,
  addedByCouponGiftLabel,
  priceHistory,
  inClearanceLabel,
  inSaleLabel,
  action,
  discount,
  isLoyalty,
  loyaltyRewardLabel,
  enableLoyalty,
}) => {
  const inSaleTagLabel = action ? inSaleLabel : null;
  const tagLabel = discount ? inClearanceLabel : inSaleTagLabel;
  const shouldShowLoyaltyLabel = isLoyalty && loyaltyRewardLabel && enableLoyalty;
  return (
    <>
      <span data-testid="product_item_brand">{brand}</span> <Bold data-testid="product_item_collection">{name}</Bold>
      <StyledSubName disabled={disabled} data-testid="product_item_subtitle">
        {subName}
      </StyledSubName>
      {addedByCoupon && !isLoyalty && (
        <Bold>
          <FormattedMessage
            {...addedByCouponGiftLabel}
            values={{
              couponCode: addedByCoupon,
            }}
          />
        </Bold>
      )}
      {(isGift || isTryItFirst) && (
        <Bold>
          {isTryItFirst ? <FormattedMessage {...tryItFirstProductLabel} /> : <FormattedMessage {...giftProductLabel} />}
        </Bold>
      )}
      {priceHistory && tagLabel && (
        <StyledInSaleTag labelStyle={ProductLabelModel.Styles.highlighted}>
          <FormattedMessage {...tagLabel} />
        </StyledInSaleTag>
      )}
      {shouldShowLoyaltyLabel && (
        <SLoyaltyRewardLabel>
          <SLoyaltyRewardWrapper>
            <SLoyaltyRewardGiftIcon />
            <FormattedMessage {...loyaltyRewardLabel} />
          </SLoyaltyRewardWrapper>
        </SLoyaltyRewardLabel>
      )}
    </>
  );
};

const withLink =
  (Component: React.ComponentType<IProductItemBodyProps>) =>
  ({ link, disabled, ...props }: IProductItemBodyWithLinkProps) => {
    if (link) {
      return (
        <StyledProductLink href={link} disabled={disabled}>
          <Component {...props} disabled={disabled} />
        </StyledProductLink>
      );
    }
    return <Component {...props} disabled={disabled} />;
  };

export const ProductItemBodyWithLink = withLink(ProductItemBody);
